module.exports = __webpack_public_path__ + "adb7cdae.png";